import { Skeleton } from 'primereact/skeleton';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../../../hooks/auth/useAuth';
import ComponentInplaceEdit from '../component-inplace-edit/ComponentInplaceEdit';

type ComponentNameSectionProps = {
  isLoading: boolean;
  mainProductName: string | undefined;
  ownProductName?: string | undefined;
  isBlurred?: boolean;
};

const ComponentNameSection = ({
  isLoading,
  mainProductName,
  ownProductName,
}: ComponentNameSectionProps): JSX.Element => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const secondaryName = ownProductName ?? '';

  const addYourOwnProductNameTemplate = (
    <div className='flex flex-row gap-2 align-items-center'>
      <i className='pi pi-plus-circle text-primary text-2xl' />
      <span className='text-primary font-bold'>
        {t('componentDetailsPage.componentNameSection.undefinedValue')}
      </span>
    </div>
  );

  if (isLoading) {
    return (
      <div className='flex flex-column gap-1'>
        <Skeleton height='46.63px' className='w-12 md:w-6 lg:w-4' />
        <Skeleton height='30px' className='w-8 md:w-4 lg:w-3' />
      </div>
    );
  }

  return (
    <div className='flex flex-column'>
      {/* Name */}
      <h1 className='text-3xl pt-2 pb-0 mb-0'>{mainProductName}</h1>

      {/* Add Your Own Name */}
      <ComponentInplaceEdit
        fieldId='ownProductName'
        value={secondaryName}
        textClassname='text-2xl'
        displayClassname='font-bold'
        customUndefinedDisplay={addYourOwnProductNameTemplate}
        disabled={user?.company?.license === 'basic'}
      />
    </div>
  );
};

export default ComponentNameSection;
